define('app/sss/data/store/sss-data-store-factory',["$localStorage"], function ($localStorage) {
	return function dataStoreFactory(id, options) {
		"use strict";
		options = options || angular.empty;
		function getDefault() {
			return angular.copy(options.default);
		}
		function validate(value) {
			return options.validate ? options.validate(value) : !!value;
		}
		return {
			get: function getFromStore() {
				var val = $localStorage.get(id);
				if (validate(val)) {
					return val;
				}
				else {
					return getDefault();
				}
			},
			set: function setToStore(value) {
				return $localStorage.set(id, value);
			}
		};
	};
});
